"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSignInCallbackUrl = void 0;
const getSearchParamValueFromUrl_1 = require("./getSearchParamValueFromUrl");
const parseSignInCallbackUrl = (urlStr) => ({
    state: (0, getSearchParamValueFromUrl_1.getSearchParamValueFromUrl)(urlStr, 'state'),
    code: (0, getSearchParamValueFromUrl_1.getSearchParamValueFromUrl)(urlStr, 'code'),
    error: (0, getSearchParamValueFromUrl_1.getSearchParamValueFromUrl)(urlStr, 'error'),
    errorDescription: (0, getSearchParamValueFromUrl_1.getSearchParamValueFromUrl)(urlStr, 'error_description'),
});
exports.parseSignInCallbackUrl = parseSignInCallbackUrl;
